import { render, staticRenderFns } from "./SelectableListItem.vue?vue&type=template&id=80953a2a&scoped=true"
import script from "./SelectableListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectableListItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SelectableListItem.vue?vue&type=style&index=0&id=80953a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80953a2a",
  null
  
)

export default component.exports